// Wrapper temático sobre react-hot-toast con los colores del design system.
import toast from 'react-hot-toast';

const baseStyle = {
  background: '#17171d',
  color: '#f5f5f7',
  border: '1px solid #26262e',
  borderRadius: '12px',
  padding: '12px 14px',
  fontSize: '14px',
  boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
  maxWidth: '380px',
};

export const toastSuccess = (message) =>
  toast.success(message, {
    style: baseStyle,
    iconTheme: { primary: '#c8f06a', secondary: '#0c0c0f' },
    duration: 3500,
  });

export const toastError = (message) =>
  toast.error(message, {
    style: baseStyle,
    iconTheme: { primary: '#ef4444', secondary: '#f5f5f7' },
    duration: 4500,
  });

export const toastInfo = (message) =>
  toast(message, {
    style: baseStyle,
    icon: 'ℹ️',
    duration: 3500,
  });

export const toastLoading = (message) =>
  toast.loading(message, {
    style: baseStyle,
  });

export const toastDismiss = (id) => toast.dismiss(id);

export default toast;
